import {z} from 'zod';

import {
  FileOperationResponseBodySchema,
  PromotionalPhotoTypeSchema,
  UuidResponseBodySchema,
  VehiclePhotoCategorySchema,
  Alpha3Schema,
  MoneySchema,
  BigDecimalSchema,
  Money,
} from '@dms/api/shared';

export type CreateCostApiResponse = /** status 201  */ CostResponseBody;
export const CreateCostRequestBodySchema = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  category: z.string().nullable(),
  businessCaseId: z.string().nullish(),
});
export type CreateCostRequestBody = z.infer<typeof CreateCostRequestBodySchema>;
export const CreateCostApiArgSchema = z.object({
  vehicleId: z.string(),
  body: CreateCostRequestBodySchema,
});
export type CreateCostApiArg = z.infer<typeof CreateCostApiArgSchema>;
export const DeleteCostApiResponseSchema = z.unknown();
export type DeleteCostApiResponse = z.infer<typeof DeleteCostApiResponseSchema>;
export const DeleteCostApiArgSchema = z.object({
  vehicleId: z.string(),
  costId: z.string(),
});
export type DeleteCostApiArg = z.infer<typeof DeleteCostApiArgSchema>;
export type EditCostApiResponse = /** status 200  */ CostResponseBody;
export const EditCostRequestBodySchema = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  category: z.string().nullable(),
});
export type EditCostRequestBody = z.infer<typeof EditCostRequestBodySchema>;
export const EditCostApiArgSchema = z.object({
  vehicleId: z.string(),
  costId: z.string(),
  body: EditCostRequestBodySchema,
});
export type EditCostApiArg = z.infer<typeof EditCostApiArgSchema>;
export const CostResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  fileName: z.string().nullable(),
  fileUri: z.string().nullable(),
  createdAt: z.string(),
  category: z.string().nullable(),
});
export type CostResponseBody = z.infer<typeof CostResponseBodySchema>;
export const GetCostApiResponseSchema = CostResponseBodySchema;
export type GetCostApiResponse = z.infer<typeof GetCostApiResponseSchema>;
export const GetCostApiArgSchema = z.object({
  costId: z.string(),
});
export type GetCostApiArg = z.infer<typeof GetCostApiArgSchema>;
export const EarningResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  fileName: z.string().nullable(),
  fileUri: z.string().nullable(),
  createdAt: z.string(),
});
export type EarningResponseBody = z.infer<typeof EarningResponseBodySchema>;
export const CreateEarningApiResponseSchema = EarningResponseBodySchema;
export type CreateEarningApiResponse = z.infer<typeof CreateEarningApiResponseSchema>;
export const CreateEarningRequestBodySchema = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
  businessCaseId: z.string().nullish(),
});
export type CreateEarningRequestBody = z.infer<typeof CreateEarningRequestBodySchema>;
export const CreateEarningApiArgSchema = z.object({
  vehicleId: z.string(),
  body: CreateEarningRequestBodySchema,
});
export type CreateEarningApiArg = z.infer<typeof CreateEarningApiArgSchema>;
export const DeleteEarningApiResponseSchema = z.unknown();
export type DeleteEarningApiResponse = z.infer<typeof DeleteEarningApiResponseSchema>;
export const DeleteEarningApiArgSchema = z.object({
  vehicleId: z.string(),
  earningId: z.string(),
});
export type DeleteEarningApiArg = z.infer<typeof DeleteEarningApiArgSchema>;
export const EditEarningApiResponseSchema = EarningResponseBodySchema;
export type EditEarningApiResponse = z.infer<typeof EditEarningApiResponseSchema>;
export const EditEarningRequestBodySchema = z.object({
  name: z.string(),
  expectedPriceWithoutVat: MoneySchema.nullable(),
  realPriceWithoutVat: MoneySchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});
export type EditEarningRequestBody = z.infer<typeof EditEarningRequestBodySchema>;
export const EditEarningApiArgSchema = z.object({
  vehicleId: z.string(),
  earningId: z.string(),
  body: EditEarningRequestBodySchema,
});
export type EditEarningApiArg = z.infer<typeof EditEarningApiArgSchema>;
export const GetEarningApiResponseSchema = EarningResponseBodySchema;
export type GetEarningApiResponse = z.infer<typeof GetEarningApiResponseSchema>;
export const GetEarningApiArgSchema = z.object({
  earningId: z.string(),
});
export type GetEarningApiArg = z.infer<typeof GetEarningApiArgSchema>;
export const FinanceSummaryResponseBodySchema = z.object({
  expectedTotalEarningsWithoutVat: MoneySchema,
  expectedTotalCostsWithoutVat: MoneySchema,
  expectedMarginWithoutVat: MoneySchema,
  realTotalEarningsWithoutVat: MoneySchema,
  realTotalCostsWithoutVat: MoneySchema,
  realMarginWithoutVat: MoneySchema,
  expectedTotalNetCostsWithoutVat: MoneySchema,
});
export type FinanceSummaryResponseBody = z.infer<typeof FinanceSummaryResponseBodySchema>;
export const GetFinanceSummaryApiResponseSchema = FinanceSummaryResponseBodySchema;
export type GetFinanceSummaryApiResponse = z.infer<typeof GetFinanceSummaryApiResponseSchema>;
export const GetFinanceSummaryApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type GetFinanceSummaryApiArg = z.infer<typeof GetFinanceSummaryApiArgSchema>;
export const ChangeBranchSaleVehicleApiResponseSchema = z.unknown();
export type ChangeBranchSaleVehicleApiResponse = z.infer<
  typeof ChangeBranchSaleVehicleApiResponseSchema
>;
export const ChangeBranchSaleVehicleRequestBodySchema = z.object({
  branchId: z.string(),
});
export type ChangeBranchSaleVehicleRequestBody = z.infer<
  typeof ChangeBranchSaleVehicleRequestBodySchema
>;
export const ChangeBranchSaleVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  changeBranchSaleVehicleRequestBody: ChangeBranchSaleVehicleRequestBodySchema,
});
export type ChangeBranchSaleVehicleApiArg = z.infer<typeof ChangeBranchSaleVehicleApiArgSchema>;

export const ChangeSaleVehicleStateToSellApiResponseSchema = z.unknown();
export type ChangeSaleVehicleStateToSellApiResponse = z.infer<
  typeof ChangeSaleVehicleStateToSellApiResponseSchema
>;
export const ChangeSaleVehicleStateToSellApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type ChangeSaleVehicleStateToSellApiArg = z.infer<
  typeof ChangeSaleVehicleStateToSellApiArgSchema
>;
export const SaleVehicleFinancialIndicatorsResponseBodySchema = z.object({
  realSellingPrice: MoneySchema.nullable(),
  realSellingPriceWithoutVat: MoneySchema.nullable(),
  discount: MoneySchema.nullable(),
  upsell: MoneySchema.nullable(),
  realCosts: MoneySchema.nullable(),
  realEarnings: MoneySchema.nullable(),
  expectedCosts: MoneySchema.nullable(),
  expectedEarnings: MoneySchema.nullable(),
  expectedAndRealCostsDifference: MoneySchema.nullable(),
  expectedAndRealEarningsDifference: MoneySchema.nullable(),
  expectedTotalGrossMargin: MoneySchema.nullable(),
  expectedVehicleGrossMargin: MoneySchema.nullable(),
  vehicleGrossMargin: MoneySchema.nullable(),
  vehicleGrossMarginPercent: z.string().nullable(),
  totalGrossMargin: MoneySchema.nullable(),
  totalGrossMarginPercent: z.string().nullable(),
  profit: MoneySchema.nullable(),
  profitPercent: z.string().nullable(),
});
export type SaleVehicleFinancialIndicatorsResponseBody = z.infer<
  typeof SaleVehicleFinancialIndicatorsResponseBodySchema
>;
export const SaleVehicleVehicleWarehouseResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
});
export type SaleVehicleVehicleWarehouseResponseBody = z.infer<
  typeof SaleVehicleVehicleWarehouseResponseBodySchema
>;
export const SaleVehiclePriceInForeignCurrencyResponseBodySchema = z.object({
  foreignCurrencyCode: z.string().nullable(),
  priceWithoutVat: z.string().nullable(),
  priceWithVat: z.string().nullable(),
});
export type SaleVehiclePriceInForeignCurrencyResponseBody = z.infer<
  typeof SaleVehiclePriceInForeignCurrencyResponseBodySchema
>;
export const AuthorResponseBodySchema = z.object({
  userId: z.string(),
  fullName: z.string(),
});
export type AuthorResponseBody = z.infer<typeof AuthorResponseBodySchema>;
export const AdvanceDepositResponseBodySchema = z.object({
  id: z.string(),
  businessCaseId: z.string(),
  incomeCashReceiptId: z.string(),
  depositedAt: z.string(),
  expenseCashReceiptId: z.string().nullable(),
});
export type AdvanceDepositResponseBody = z.infer<typeof AdvanceDepositResponseBodySchema>;
export const ReservationResponseBodySchema = z.object({
  reservedUntil: z.string(),
  expired: z.boolean(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  createdAt: z.string(),
  createdBy: AuthorResponseBodySchema,
  paidAdvanceDeposit: AdvanceDepositResponseBodySchema.nullable(),
  refundedAdvanceDeposits: z.array(AdvanceDepositResponseBodySchema),
  customerId: z.string().nullable(),
  businessCaseId: z.string().nullable(),
  canceledAt: z.string(),
});
export type ReservationResponseBody = z.infer<typeof ReservationResponseBodySchema>;
export const SaleVehiclePriceResponseBodySchema = z.object({
  withoutVat: MoneySchema.nullable(),
  withVat: MoneySchema.nullable(),
  vatRate: z.string().nullable(),
});
export type SaleVehiclePriceResponseBody = z.infer<typeof SaleVehiclePriceResponseBodySchema>;
export const EffectivePromoPhotoResponseBodySchema = z.object({
  fileId: z.string(),
  position: z.number(),
  source: z.enum(['own', 'campaign']),
  remoteFileId: z.string().nullable(),
  url: z.string().nullable(),
});
export type EffectivePromoPhotoResponseBody = z.infer<typeof EffectivePromoPhotoResponseBodySchema>;
export const SaleVehicleResponseBodySchema = z.object({
  id: z.string(),
  vehicleId: z.string(),
  branchId: z.string(),
  type: z.enum(['IN_STOCK', 'BROKERAGE']),
  createdAt: z.string(),
  state: z.enum(['BUYING', 'FAILED', 'TO_SELL', 'RESERVED', 'SOLD']).nullable(),
  sellingPrice: SaleVehiclePriceResponseBodySchema,
  b2bSellingPrice: SaleVehiclePriceResponseBodySchema,
  realSellingPrice: SaleVehiclePriceResponseBodySchema,
  purchasePrice: SaleVehiclePriceResponseBodySchema,
  profitPrice: SaleVehiclePriceResponseBodySchema,
  profitPercent: BigDecimalSchema.nullable(),
  isVatDeductible: z.boolean().nullable(),
  vatCode: z.string().nullable(),
  purchasePriceVatCode: z.string(),
  salePriceVatCode: z.string(),
  b2bSalePriceVatCode: z.string(),
  currency: Alpha3Schema.nullable(),
  sellingState: z
    .enum([
      'not-set',
      'for-sale',
      'selling',
      'contract',
      'payment-pending',
      'sold',
      'handed-over',
      'not-for-sale',
      'not-sold',
      'cannot-be-sold',
    ])
    .nullable(),
  buyingState: z
    .enum([
      'not-set',
      'to-buy',
      'buying',
      'for-pricing',
      'priced',
      'contract',
      'bought',
      'not-bought',
      'returned-to-customer',
    ])
    .nullable(),
  isAvailable: z.boolean(),
  activeReservation: ReservationResponseBodySchema.nullable(),
  nonActiveReservations: z.array(ReservationResponseBodySchema),
  saleBusinessCaseId: z.string().nullable(),
  vehicleWarehouse: SaleVehicleVehicleWarehouseResponseBodySchema.nullable(),
  isPhotographed: z.boolean(),
  originalCarPrice: MoneySchema.nullable(),
  leasingAndCreditCompany: z.boolean(),
  leasingAndCreditCompanyCodeId: z.string().nullable(),
  endOfFinancing: z.string().nullable(),
  financingContractNumber: z.string().nullable(),
  financingNote: z.string().nullable(),
  isNotClosedBusinessCase: z.boolean(),
  closedSellingBusinessCaseDate: z.string().nullable(),
  // Optional for compatibility with backends that predate new-vehicle delivery facts.
  incoming: z.boolean().optional(),
  incomingEta: z.string().nullable().optional(),
  hasUnarrivedVehicleOrder: z.boolean().optional(),
  isClosedPurchaseBusinessCase: z.boolean(),
  purchasePriceIsForeignCurrency: SaleVehiclePriceInForeignCurrencyResponseBodySchema.nullable(),
  sellingPriceIsForeignCurrency: SaleVehiclePriceInForeignCurrencyResponseBodySchema.nullable(),
  financialIndicators: SaleVehicleFinancialIndicatorsResponseBodySchema,
  stockInDate: z.string().nullable(),
  purchaseDate: z.string().nullable(),
  purchaseMileage: z.number().nullable(),
  saleMileage: z.number().nullable(),
  watermarkId: z.string().nullable(),
  editableWatermarkIds: z.array(z.string()),
  effectiveWatermarkIds: z.array(z.string()),
  soldAt: z.string().nullable(),
  salePresetId: z.string().nullable(),
  qualitySealKey: z.string().nullable(),
  qualitySealManual: z.boolean(),
  qualitySeal: z
    .object({
      key: z.string(),
      displayName: z.string(),
      status: z.enum(['ACTIVE', 'DISCONTINUED']),
    })
    .nullable(),
  warrantyProgramId: z.string().nullable(),
  warrantyDuration: z.number().nullable(),
  defaultWarrantyDuration: z.number().nullable(),
  isWarrantyProgramResolvedFromSalePreset: z.boolean(),
  isWarrantyProgramResolvedFromCampaign: z.boolean(),
  vehicleSourceCodeId: z.string().nullable(),
  effectivePromoPhotos: z.array(EffectivePromoPhotoResponseBodySchema),
  isPromoPhotosResolvedFromCampaign: z.boolean(),
});
export type SaleVehicleResponseBody = z.infer<typeof SaleVehicleResponseBodySchema>;
export const GetSaleVehicleApiResponseSchema = SaleVehicleResponseBodySchema;
export type GetSaleVehicleApiResponse = z.infer<typeof GetSaleVehicleApiResponseSchema>;
export const GetSaleVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type GetSaleVehicleApiArg = z.infer<typeof GetSaleVehicleApiArgSchema>;
export const UpdateSaleVehicleApiResponseSchema = z.unknown();
export type UpdateSaleVehicleApiResponse = z.infer<typeof UpdateSaleVehicleApiResponseSchema>;
export const UpdateSaleVehicleRequestBodySchema = z.object({
  sellingPrice: z.string().nullable(),
  sellingPriceWithVat: z.string().nullable(),
  sellingPriceVatRate: z.string().nullable(),
  purchasePrice: z.string().nullable(),
  purchasePriceWithVat: z.string().nullable(),
  purchasePriceVatRate: z.string().nullable(),
  currencyCode: z.string().nullable(),
  isVatDeductible: z.boolean().nullable(),
  vatCode: z.string().nullable(),
  updateReasonNote: z.string().nullable(),
  originalCarPrice: z.string().nullable(),
});
export type UpdateSaleVehicleRequestBody = z.infer<typeof UpdateSaleVehicleRequestBodySchema>;
export const UpdateSaleVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  businessCaseId: z.string(),
  updateSaleVehicleRequestBody: UpdateSaleVehicleRequestBodySchema,
});
export type UpdateSaleVehicleApiArg = z.infer<typeof UpdateSaleVehicleApiArgSchema>;
export const SaleVehicleByVehicleResponseBodySchema = z.object({
  activeSaleVehicleId: z.string().nullable(),
  saleVehicleIds: z.array(z.string()),
});
export type SaleVehicleByVehicleResponseBody = z.infer<
  typeof SaleVehicleByVehicleResponseBodySchema
>;

export const GetSaleVehicleByVehicleApiResponseSchema = SaleVehicleByVehicleResponseBodySchema;
export type GetSaleVehicleByVehicleApiResponse = z.infer<
  typeof GetSaleVehicleByVehicleApiResponseSchema
>;
export const GetSaleVehicleByVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  type: z.enum(['IN_STOCK', 'BROKERAGE']).optional(),
});
export type GetSaleVehicleByVehicleApiArg = z.infer<typeof GetSaleVehicleByVehicleApiArgSchema>;
export const MakeSaleVehicleAvailableForSaleApiResponseSchema = z.unknown();
export type MakeSaleVehicleAvailableForSaleApiResponse = z.infer<
  typeof MakeSaleVehicleAvailableForSaleApiResponseSchema
>;
export const MakeSaleVehicleAvailableForSaleApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleAvailableForSaleApiArg = z.infer<
  typeof MakeSaleVehicleAvailableForSaleApiArgSchema
>;
export const MakeSaleVehicleIsNotForSaleApiResponseSchema = z.unknown();
export type MakeSaleVehicleIsNotForSaleApiResponse = z.infer<
  typeof MakeSaleVehicleIsNotForSaleApiResponseSchema
>;
export const MakeSaleVehicleIsNotForSaleApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleIsNotForSaleApiArg = z.infer<
  typeof MakeSaleVehicleIsNotForSaleApiArgSchema
>;
export const MakeSaleVehicleIsNotSoldApiResponseSchema = z.unknown();
export type MakeSaleVehicleIsNotSoldApiResponse = z.infer<
  typeof MakeSaleVehicleIsNotSoldApiResponseSchema
>;
export const MakeSaleVehicleIsNotSoldApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleIsNotSoldApiArg = z.infer<typeof MakeSaleVehicleIsNotSoldApiArgSchema>;
export const MakeSaleVehicleIsReturnedToCustomerApiResponseSchema = z.unknown();
export type MakeSaleVehicleIsReturnedToCustomerApiResponse = z.infer<
  typeof MakeSaleVehicleIsReturnedToCustomerApiResponseSchema
>;
export const MakeSaleVehicleIsReturnedToCustomerApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type MakeSaleVehicleIsReturnedToCustomerApiArg = z.infer<
  typeof MakeSaleVehicleIsReturnedToCustomerApiArgSchema
>;
export const ReRegisterVehicleForSaleApiResponseSchema = z.unknown();
export type ReRegisterVehicleForSaleApiResponse = z.infer<
  typeof ReRegisterVehicleForSaleApiResponseSchema
>;
export const ReRegisterVehicleForSaleApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type ReRegisterVehicleForSaleApiArg = z.infer<typeof ReRegisterVehicleForSaleApiArgSchema>;
export const ApplyCostPresetRequestBodySchema = z.object({
  costPresetIds: z.array(z.string()),
  businessCaseId: z.string().nullish(),
});
export type ApplyCostPresetRequestBody = z.infer<typeof ApplyCostPresetRequestBodySchema>;
export const CreateCostPresetRequestBodySchema = z.object({
  name: z.string(),
});
export type CreateCostPresetRequestBody = z.infer<typeof CreateCostPresetRequestBodySchema>;
export const CostPresetResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
});
export type CostPresetResponseBody = z.infer<typeof CostPresetResponseBodySchema>;
export const ApplyCostPresetApiArgSchema = z.object({
  vehicleId: z.string(),
  body: ApplyCostPresetRequestBodySchema,
});
export type ApplyCostPresetApiArg = z.infer<typeof ApplyCostPresetApiArgSchema>;
export const CreateCostPresetApiArgSchema = z.object({
  vehicleId: z.string(),
  body: CreateCostPresetRequestBodySchema,
});
export type CreateCostPresetApiArg = z.infer<typeof CreateCostPresetApiArgSchema>;
export const DeleteCostPresetApiArgSchema = z.object({
  costPresetId: z.string(),
});
export type DeleteCostPresetApiArg = z.infer<typeof DeleteCostPresetApiArgSchema>;
export const GetCostPresetListApiResponseSchema = z.array(CostPresetResponseBodySchema);
export type GetCostPresetListApiResponse = z.infer<typeof GetCostPresetListApiResponseSchema>;
export const CostPresetBodySchema = z.object({
  value: z.string(),
  label: z.string(),
});
export type CostPresetBody = z.infer<typeof CostPresetBodySchema>;
export const GetCostPresetListResultSchema = z.array(CostPresetBodySchema);
export type GetCostPresetListResult = z.infer<typeof GetCostPresetListResultSchema>;
export const ApplyEarningPresetRequestBodySchema = z.object({
  earningPresetIds: z.array(z.string()),
  businessCaseId: z.string().nullable().optional(),
});
export type ApplyEarningPresetRequestBody = z.infer<typeof ApplyEarningPresetRequestBodySchema>;
export const CreateEarningPresetRequestBodySchema = z.object({
  name: z.string(),
});
export type CreateEarningPresetRequestBody = z.infer<typeof CreateEarningPresetRequestBodySchema>;
export const EarningPresetResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
});
export type EarningPresetResponseBody = z.infer<typeof EarningPresetResponseBodySchema>;
export const ApplyEarningPresetApiArgSchema = z.object({
  vehicleId: z.string(),
  body: ApplyEarningPresetRequestBodySchema,
});
export type ApplyEarningPresetApiArg = z.infer<typeof ApplyEarningPresetApiArgSchema>;
export const CreateEarningPresetApiArgSchema = z.object({
  vehicleId: z.string(),
  body: CreateEarningPresetRequestBodySchema,
});
export type CreateEarningPresetApiArg = z.infer<typeof CreateEarningPresetApiArgSchema>;
export const DeleteEarningPresetApiArgSchema = z.object({
  earningPresetId: z.string(),
});
export type DeleteEarningPresetApiArg = z.infer<typeof DeleteEarningPresetApiArgSchema>;
export const GetEarningPresetListApiResponseSchema = z.array(EarningPresetResponseBodySchema);
export type GetEarningPresetListApiResponse = z.infer<typeof GetEarningPresetListApiResponseSchema>;
export const GetEarningPresetListResultSchema = z.array(CostPresetBodySchema);
export type GetEarningPresetListResult = z.infer<typeof GetEarningPresetListResultSchema>;
export const SaleVehicleSellingStateSchema = z
  .enum([
    'not-set',
    'for-sale',
    'selling',
    'not-for-sale',
    'sold',
    'not-sold',
    'contract',
    'payment-pending',
    'handed-over',
    'cannot-be-sold',
  ])
  .nullable();
export type SaleVehicleSellingState = z.infer<typeof SaleVehicleSellingStateSchema>;
export const SaleVehicleBuyingStateSchema = z
  .enum([
    'not-set',
    'buying',
    'for-pricing',
    'priced',
    'not-bought',
    'bought',
    'returned-to-customer',
    'to-buy',
    'contract',
  ])
  .nullable();
export type SaleVehicleBuyingState = z.infer<typeof SaleVehicleBuyingStateSchema>;
export const ReserveSaleVehicleApiResponseSchema = z.unknown();
export type ReserveSaleVehicleApiResponse = z.infer<typeof ReserveSaleVehicleApiResponseSchema>;
export const ReserveSaleVehicleRequestBodySchema = z.object({
  reserveUntil: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullable().optional(),
  businessCaseId: z.string().nullable().optional(),
});
export type ReserveSaleVehicleRequestBody = z.infer<typeof ReserveSaleVehicleRequestBodySchema>;
export const ReserveSaleVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  body: ReserveSaleVehicleRequestBodySchema,
});
export type ReserveSaleVehicleApiArg = z.infer<typeof ReserveSaleVehicleApiArgSchema>;
export const UpdateSaleVehicleReservationRequestBodySchema = z.object({
  reserveUntil: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullable().optional(),
  businessCaseId: z.string().nullable().optional(),
});
export type UpdateSaleVehicleReservationRequestBody = z.infer<
  typeof UpdateSaleVehicleReservationRequestBodySchema
>;
export const CancelSaleVehicleReservationApiResponseSchema = z.unknown();
export type CancelSaleVehicleReservationApiResponse = z.infer<
  typeof CancelSaleVehicleReservationApiResponseSchema
>;
export const CancelSaleVehicleReservationApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type CancelSaleVehicleReservationApiArg = z.infer<
  typeof CancelSaleVehicleReservationApiArgSchema
>;
export const UpdateSaleVehicleReservationApiResponseSchema = z.unknown();
export type UpdateSaleVehicleReservationApiResponse = z.infer<
  typeof UpdateSaleVehicleReservationApiResponseSchema
>;
export const UpdateSaleVehicleReservationApiArgSchema = z.object({
  vehicleId: z.string(),
  body: UpdateSaleVehicleReservationRequestBodySchema,
});
export type UpdateSaleVehicleReservationApiArg = z.infer<
  typeof UpdateSaleVehicleReservationApiArgSchema
>;
export const ReserveSaleVehicleWithAdvanceDepositRequestBodySchema = z.object({
  reserveUntil: z.string(),
  reservationNote: z.string().nullable(),
  cashReceiptNote: z.string().nullable(),
  businessCaseId: z.string(),
  customerId: z.string(),
  cashRegisterId: z.string(),
  issuedAt: z.string(),
  amount: MoneySchema,
});
export type ReserveSaleVehicleWithAdvanceDepositRequestBody = z.infer<
  typeof ReserveSaleVehicleWithAdvanceDepositRequestBodySchema
>;
export const ReserveSaleVehicleWithAdvanceDepositApiResponseSchema = z.unknown();
export type ReserveSaleVehicleWithAdvanceDepositApiResponse = z.infer<
  typeof ReserveSaleVehicleWithAdvanceDepositApiResponseSchema
>;
export const ReserveSaleVehicleWithAdvanceDepositApiArgSchema = z.object({
  vehicleId: z.string(),
  body: ReserveSaleVehicleWithAdvanceDepositRequestBodySchema,
});
export type ReserveSaleVehicleWithAdvanceDepositApiArg = z.infer<
  typeof ReserveSaleVehicleWithAdvanceDepositApiArgSchema
>;
export const RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySchema = z.object({
  issuedAt: z.string(),
});
export type RefundAdvanceDepositInSaleVehicleActiveReservationRequestBody = z.infer<
  typeof RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySchema
>;
export const RefundAdvanceDepositInSaleVehicleActiveReservationApiResponseSchema = z.unknown();
export type RefundAdvanceDepositInSaleVehicleActiveReservationApiResponse = z.infer<
  typeof RefundAdvanceDepositInSaleVehicleActiveReservationApiResponseSchema
>;
export const RefundAdvanceDepositInSaleVehicleActiveReservationApiArgSchema = z.object({
  vehicleId: z.string(),
  refundAdvanceDepositInSaleVehicleActiveReservationRequestBody:
    RefundAdvanceDepositInSaleVehicleActiveReservationRequestBodySchema,
});
export type RefundAdvanceDepositInSaleVehicleActiveReservationApiArg = z.infer<
  typeof RefundAdvanceDepositInSaleVehicleActiveReservationApiArgSchema
>;
export const CancelAdvanceDepositInSaleVehicleActiveReservationApiResponseSchema = z.unknown();
export type CancelAdvanceDepositInSaleVehicleActiveReservationApiResponse = z.infer<
  typeof CancelAdvanceDepositInSaleVehicleActiveReservationApiResponseSchema
>;
export const CancelAdvanceDepositInSaleVehicleActiveReservationApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type CancelAdvanceDepositInSaleVehicleActiveReservationApiArg = z.infer<
  typeof CancelAdvanceDepositInSaleVehicleActiveReservationApiArgSchema
>;
export const AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySchema = z.object({
  note: z.string().nullable(),
  businessCaseId: z.string(),
  customerId: z.string(),
  cashRegisterId: z.string(),
  issuedAt: z.string(),
  amount: MoneySchema,
});
export type AddAdvanceDepositToSaleVehicleActiveReservationRequestBody = z.infer<
  typeof AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySchema
>;
export const AddAdvanceDepositToSaleVehicleActiveReservationApiResponseSchema = z.unknown();
export type AddAdvanceDepositToSaleVehicleActiveReservationApiResponse = z.infer<
  typeof AddAdvanceDepositToSaleVehicleActiveReservationApiResponseSchema
>;
export const AddAdvanceDepositToSaleVehicleActiveReservationApiArgSchema = z.object({
  vehicleId: z.string(),
  body: AddAdvanceDepositToSaleVehicleActiveReservationRequestBodySchema,
});
export type AddAdvanceDepositToSaleVehicleActiveReservationApiArg = z.infer<
  typeof AddAdvanceDepositToSaleVehicleActiveReservationApiArgSchema
>;
export const DeleteLeasingAndCreditCompanyApiResponseSchema = z.unknown();
export type DeleteLeasingAndCreditCompanyApiResponse = z.infer<
  typeof DeleteLeasingAndCreditCompanyApiResponseSchema
>;
export const DeleteLeasingAndCreditCompanyApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type DeleteLeasingAndCreditCompanyApiArg = z.infer<
  typeof DeleteLeasingAndCreditCompanyApiArgSchema
>;
export const EnableLeasingAndCreditCompanyApiResponseSchema = z.object({});
export type EnableLeasingAndCreditCompanyApiResponse = z.infer<
  typeof EnableLeasingAndCreditCompanyApiResponseSchema
>;
export const EnableLeasingAndCreditCompanyApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type EnableLeasingAndCreditCompanyApiArg = z.infer<
  typeof EnableLeasingAndCreditCompanyApiArgSchema
>;
export const LeasingAndCreditCompanyApiResponseSchema = z.object({});
export type LeasingAndCreditCompanyApiResponse = z.infer<
  typeof LeasingAndCreditCompanyApiResponseSchema
>;
export const LeasingAndCreditCompanyRequestBodySchema = z.object({
  endOfFinancing: z.string().nullable(),
  financingContractNumber: z.string().nullable(),
  note: z.string().nullable(),
});
export type LeasingAndCreditCompanyRequestBody = z.infer<
  typeof LeasingAndCreditCompanyRequestBodySchema
>;
export const LeasingAndCreditCompanyApiArgSchema = z.object({
  vehicleId: z.string(),
  codeId: z.string(),
  body: LeasingAndCreditCompanyRequestBodySchema,
});
export type LeasingAndCreditCompanyApiArg = z.infer<typeof LeasingAndCreditCompanyApiArgSchema>;
export const GetVehicleSalesActionsApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type GetVehicleSalesActionsApiArg = z.infer<typeof GetVehicleSalesActionsApiArgSchema>;
export const VehicleSalesActionSchema = z.enum([
  'SALE_VEHICLE_TEMPORARY_REMOVE_FROM_SALE',
  'SALE_VEHICLE_REMOVE_FROM_SALE',
  'SALE_VEHICLE_SELL',
  'SALE_VEHICLE_PUT_BACK_UP_FOR_SALE',
  'SALE_VEHICLE_RE_REGISTER_FOR_SALE',
  'SALE_VEHICLE_BUY',
  'SALE_VEHICLE_RESERVE',
  'SALE_VEHICLE_UPDATE',
  'SALE_VEHICLE_ADD_EXPECTED_COST',
  'SALE_VEHICLE_EDIT_EXPECTED_COST',
  'SALE_VEHICLE_REMOVE_EXPECTED_COST',
  'SALE_VEHICLE_UPDATE_SELLING_DATE',
  'SALE_VEHICLE_UPDATE_BUYING_DATE',
  'CORRECT_PURCHASE_DATE',
  'CORRECT_SALE_DATE',
  'BUY_VEHICLE',
  'SELL_VEHICLE',
]);
export type VehicleSalesAction = z.infer<typeof VehicleSalesActionSchema>;
export const VehicleSalesActionsResponseBodySchema = z.object({
  actions: z.array(VehicleSalesActionSchema),
});
export type VehicleSalesActionsResponseBody = z.infer<typeof VehicleSalesActionsResponseBodySchema>;
export const GetVehicleSalesActionsApiResponseSchema = VehicleSalesActionsResponseBodySchema;
export type GetVehicleSalesActionsApiResponse = z.infer<
  typeof GetVehicleSalesActionsApiResponseSchema
>;
export const PatchVehiclePricesApiResponseSchema = z.unknown();
export type PatchVehiclePricesApiResponse = z.infer<typeof PatchVehiclePricesApiResponseSchema>;
export const PriceWithVatRequestBodySchema = z.object({
  vatCode: z.string(),
  withoutVat: z.string().nullable(),
  withVat: z.string().nullable(),
  vatRate: z.string().nullable(),
});
export type PriceWithVatRequestBody = z.infer<typeof PriceWithVatRequestBodySchema>;
export const PriceInForeignCurrencyRequestBodySchema = z.object({
  foreignCurrencyCode: z.string(),
  priceWithoutVat: z.string().nullable(),
  priceWithVat: z.string().nullable(),
});

export type PriceInForeignCurrencyRequestBody = z.infer<
  typeof PriceInForeignCurrencyRequestBodySchema
>;
export const PatchVehiclePricesRequestBodySchema = z.object({
  isVatDeductible: z.boolean().nullish(),
  purchasePrice: PriceWithVatRequestBodySchema.nullish(),
  sellingPrice: PriceWithVatRequestBodySchema.nullish(),
  b2bSellingPrice: PriceWithVatRequestBodySchema.nullish(),
  purchasePriceInForeignCurrency: PriceInForeignCurrencyRequestBodySchema.nullish(),
  sellingPriceInForeignCurrency: PriceInForeignCurrencyRequestBodySchema.nullish(),
  originalCarPrice: z.string().nullish(),
  updateReasonNote: z.string().nullish(),
});

export type PatchVehiclePricesRequestBody = z.infer<typeof PatchVehiclePricesRequestBodySchema>;
export const PatchVehiclePricesApiArgSchema = z.object({
  vehicleId: z.string(),
  patchVehiclePricesRequestBody: PatchVehiclePricesRequestBodySchema,
});
export type PatchVehiclePricesApiArg = z.infer<typeof PatchVehiclePricesApiArgSchema>;
export const CancelVehicleReservationApiResponseSchema = z.unknown();
export type CancelVehicleReservationApiResponse = z.infer<
  typeof CancelVehicleReservationApiResponseSchema
>;
export const CancelVehicleReservationApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type CancelVehicleReservationApiArg = z.infer<typeof CancelVehicleReservationApiArgSchema>;
export const UpdateVehicleReservationRequestBodySchema = z.object({
  reserveUntil: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});

export type UpdateVehicleReservationRequestBody = z.infer<
  typeof UpdateVehicleReservationRequestBodySchema
>;
export const UpdateVehicleReservationApiResponseSchema = z.unknown();
export type UpdateVehicleReservationApiResponse = z.infer<
  typeof UpdateVehicleReservationApiResponseSchema
>;
export const UpdateVehicleReservationApiArgSchema = z.object({
  vehicleId: z.string(),
  body: UpdateVehicleReservationRequestBodySchema,
});
export type UpdateVehicleReservationApiArg = z.infer<typeof UpdateVehicleReservationApiArgSchema>;
export const UpdateVehicleReservationV2RequestBodySchema = z.object({
  reserveUntilAt: z.string(),
  customer: z.string().nullable(),
  note: z.string().nullable(),
  customerId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});
export type UpdateVehicleReservationV2RequestBody = z.infer<
  typeof UpdateVehicleReservationV2RequestBodySchema
>;
export const UpdateVehicleReservationV2ApiResponseSchema = z.unknown();
export type UpdateVehicleReservationV2ApiResponse = z.infer<
  typeof UpdateVehicleReservationV2ApiResponseSchema
>;
export const UpdateVehicleReservationV2ApiArgSchema = z.object({
  vehicleId: z.string(),
  body: UpdateVehicleReservationV2RequestBodySchema,
});
export type UpdateVehicleReservationV2ApiArg = z.infer<
  typeof UpdateVehicleReservationV2ApiArgSchema
>;
export const VehicleActiveReservationApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type VehicleActiveReservationApiArg = z.infer<typeof VehicleActiveReservationApiArgSchema>;
export type VehicleReservationResponseBody = z.infer<typeof VehicleReservationResponseBodySchema>;
export const VehicleReservationCustomerResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type VehicleReservationCustomerResponseBody = z.infer<
  typeof VehicleReservationCustomerResponseBodySchema
>;
export const VehicleReservationBusinessCaseResponseBodySchema = z.object({
  id: z.string(),
  code: z.string(),
});
export type VehicleReservationBusinessCaseResponseBody = z.infer<
  typeof VehicleReservationBusinessCaseResponseBodySchema
>;
export const VehicleReservationDepositResponseBodySchema = z.object({
  incomeCashReceiptId: z.string(),
  expenseCashReceiptId: z.string().nullable(),
});
export type VehicleReservationDepositResponseBody = z.infer<
  typeof VehicleReservationDepositResponseBodySchema
>;
export const VehicleReservationUserResponseBodySchema = z.object({
  id: z.string(),
  fullName: z.string(),
});
export type VehicleReservationUserResponseBody = z.infer<
  typeof VehicleReservationUserResponseBodySchema
>;
export const VehicleReservationResponseBodySchema = z.object({
  reservedUntil: z.string(),
  reservedUntilAt: z.string(),
  isExpired: z.boolean(),
  note: z.string().nullable(),
  customer: VehicleReservationCustomerResponseBodySchema.nullable(),
  businessCase: VehicleReservationBusinessCaseResponseBodySchema.nullable(),
  paidDeposit: VehicleReservationDepositResponseBodySchema.nullable(),
  refundedDeposits: VehicleReservationDepositResponseBodySchema.array(),
  createdAt: z.string(),
  createdBy: VehicleReservationUserResponseBodySchema,
  canceledAt: z.string().nullable(),
  canceledBy: VehicleReservationUserResponseBodySchema.nullable(),
});
export const VehicleActiveReservationApiResponseSchema = VehicleReservationResponseBodySchema;
export type VehicleActiveReservationApiResponse = z.infer<
  typeof VehicleActiveReservationApiResponseSchema
>;
export const AddVehicleReservationDepositApiResponseSchema = z.unknown();
export type AddVehicleReservationDepositApiResponse = z.infer<
  typeof AddVehicleReservationDepositApiResponseSchema
>;
export const AddVehicleReservationDepositRequestBodySchema = z.object({
  note: z.string().nullable(),
  businessCaseId: z.string(),
  customerId: z.string(),
  cashRegisterId: z.string(),
  issuedAt: z.string(),
  amount: MoneySchema,
});
export type AddVehicleReservationDepositRequestBody = z.infer<
  typeof AddVehicleReservationDepositRequestBodySchema
>;
export const AddVehicleReservationDepositApiArgSchema = z.object({
  vehicleId: z.string(),
  'X-Branch': z.string(),
  body: AddVehicleReservationDepositRequestBodySchema,
});
export type AddVehicleReservationDepositApiArg = z.infer<
  typeof AddVehicleReservationDepositApiArgSchema
>;

export const CancelVehicleReservationDepositApiResponseSchema = z.unknown();

export type CancelVehicleReservationDepositApiResponse = z.infer<
  typeof CancelVehicleReservationDepositApiResponseSchema
>;
export const CancelVehicleReservationDepositApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type CancelVehicleReservationDepositApiArg = z.infer<
  typeof CancelVehicleReservationDepositApiArgSchema
>;
export const VehicleReservationHistoryApiResponseSchema = z.array(
  VehicleReservationResponseBodySchema
);
export type VehicleReservationHistoryApiResponse = z.infer<
  typeof VehicleReservationHistoryApiResponseSchema
>;
export const VehicleReservationHistoryApiArgSchema = z.object({
  vehicleId: z.string(),
  saleVehicleId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});
export type VehicleReservationHistoryApiArg = z.infer<typeof VehicleReservationHistoryApiArgSchema>;
export const RefundVehicleReservationDepositApiResponseSchema = z.unknown();
export type RefundVehicleReservationDepositApiResponse = z.infer<
  typeof RefundVehicleReservationDepositApiResponseSchema
>;
export const RefundVehicleReservationDepositRequestBodySchema = z.object({
  issuedAt: z.string(),
});
export type RefundVehicleReservationDepositRequestBody = z.infer<
  typeof RefundVehicleReservationDepositRequestBodySchema
>;
export const RefundVehicleReservationDepositApiArgSchema = z.object({
  vehicleId: z.string(),
  'X-Branch': z.string(),
  body: RefundVehicleReservationDepositRequestBodySchema,
});
export type RefundVehicleReservationDepositApiArg = z.infer<
  typeof RefundVehicleReservationDepositApiArgSchema
>;
export const ReserveVehicleApiResponseSchema = z.unknown();

export type ReserveVehicleApiResponse = z.infer<typeof ReserveVehicleApiResponseSchema>;
export const ReserveVehicleRequestBodySchema = z.object({
  reserveUntil: z.string(),
  note: z.string().nullable(),
  customerId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});
export type ReserveVehicleRequestBody = z.infer<typeof ReserveVehicleRequestBodySchema>;
export const ReserveVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  body: ReserveVehicleRequestBodySchema,
});
export type ReserveVehicleApiArg = z.infer<typeof ReserveVehicleApiArgSchema>;
export const ReserveVehicleV2ApiResponseSchema = z.unknown();
export type ReserveVehicleV2ApiResponse = z.infer<typeof ReserveVehicleV2ApiResponseSchema>;
export const ReserveVehicleV2RequestBodySchema = z.object({
  reserveUntilAt: z.string(),
  note: z.string().nullable(),
  customerId: z.string().nullish(),
  businessCaseId: z.string().nullish(),
});
export type ReserveVehicleV2RequestBody = z.infer<typeof ReserveVehicleV2RequestBodySchema>;
export const ReserveVehicleV2ApiArgSchema = z.object({
  vehicleId: z.string(),
  body: ReserveVehicleV2RequestBodySchema,
});
export type ReserveVehicleV2ApiArg = z.infer<typeof ReserveVehicleV2ApiArgSchema>;
export const GetActiveSaleVehicleApiResponseSchema = SaleVehicleResponseBodySchema;
export type GetActiveSaleVehicleApiResponse = z.infer<typeof GetActiveSaleVehicleApiResponseSchema>;
export const GetActiveSaleVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
});
export type GetActiveSaleVehicleApiArg = z.infer<typeof GetActiveSaleVehicleApiArgSchema>;
export const SaleVehicleAlbumResponseBodySchema = z.object({
  translation: z.string(),
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  photosUpdatedAt: z.string().nullable(),
});
export type SaleVehicleAlbumResponseBody = z.infer<typeof SaleVehicleAlbumResponseBodySchema>;
export const ListSaleVehicleAlbumsApiResponseSchema = z.array(SaleVehicleAlbumResponseBodySchema);
export type ListSaleVehicleAlbumsApiResponse = z.infer<
  typeof ListSaleVehicleAlbumsApiResponseSchema
>;
export const ListSaleVehicleAlbumsApiArgSchema = z.object({
  saleVehicleId: z.string().optional(),
});
export type ListSaleVehicleAlbumsApiArg = z.infer<typeof ListSaleVehicleAlbumsApiArgSchema>;
export const CreateSaleVehicleAlbumResponseBodySchema = z.object({
  saleVehicleAlbumId: z.string(),
});
export type CreateSaleVehicleAlbumResponseBody = z.infer<
  typeof CreateSaleVehicleAlbumResponseBodySchema
>;
export const CreateSaleVehicleAlbumApiResponseSchema = CreateSaleVehicleAlbumResponseBodySchema;
export type CreateSaleVehicleAlbumApiResponse = z.infer<
  typeof CreateSaleVehicleAlbumApiResponseSchema
>;
export const CreateSaleVehicleAlbumRequestBodySchema = z.object({
  saleVehicleId: z.string(),
  name: z.enum([
    'PHOTOS_CAR_ORIGINAL',
    'PHOTOS_CAR_PURCHASE',
    'PHOTOS_CAR_SALES',
    'PHOTOS_SERVICE_CASE',
    'PHOTOS_CUSTOM',
  ]),
  description: z.string().nullish(),
});
export type CreateSaleVehicleAlbumRequestBody = z.infer<
  typeof CreateSaleVehicleAlbumRequestBodySchema
>;
export const CreateSaleVehicleAlbumApiArgSchema = z.object({
  createSaleVehicleAlbumRequestBody: CreateSaleVehicleAlbumRequestBodySchema,
});

export type CreateSaleVehicleAlbumApiArg = z.infer<typeof CreateSaleVehicleAlbumApiArgSchema>;
export const SaleVehiclePhotoResponseBodySchema = z.object({
  id: z.string(),
  fileId: z.string(),
  albumId: z.string(),
  weight: z.number(),
  isCoverPhoto: z.boolean(),
  url: z.string(),
  category: VehiclePhotoCategorySchema.nullable(),
});
export type SaleVehiclePhotoResponseBody = z.infer<typeof SaleVehiclePhotoResponseBodySchema>;
export const AddFilesToSaleVehicleAlbumRequestBodySchema = z.object({
  fileIds: z.array(z.string()),
});
export type AddFilesToSaleVehicleAlbumRequestBody = z.infer<
  typeof AddFilesToSaleVehicleAlbumRequestBodySchema
>;
export const AddFilesToSaleVehicleAlbumResponseBodySchema = z.object({
  photos: z.array(SaleVehiclePhotoResponseBodySchema),
});
export type AddFilesToSaleVehicleAlbumResponseBody = z.infer<
  typeof AddFilesToSaleVehicleAlbumResponseBodySchema
>;
export const AddFilesToSaleVehicleAlbumApiResponseSchema =
  AddFilesToSaleVehicleAlbumResponseBodySchema;
export type AddFilesToSaleVehicleAlbumApiResponse = z.infer<
  typeof AddFilesToSaleVehicleAlbumApiResponseSchema
>;
export const AddFilesToSaleVehicleAlbumApiArgSchema = z.object({
  saleVehicleAlbumId: z.string(),
  addFilesToSaleVehicleAlbumRequestBody: AddFilesToSaleVehicleAlbumRequestBodySchema,
});
export type AddFilesToSaleVehicleAlbumApiArg = z.infer<
  typeof AddFilesToSaleVehicleAlbumApiArgSchema
>;
export const SaleVehicleAlbumPhotoResponseBodySchema = z.object({
  id: z.string(),
  weight: z.number(),
  fileId: z.string(),
  remoteFileId: z.string(),
  isCoverPhoto: z.boolean(),
  url: z.string(),
  latestFileOperation: FileOperationResponseBodySchema.nullable(),
  category: VehiclePhotoCategorySchema.nullable(),
});
export type SaleVehicleAlbumPhotoResponseBody = z.infer<
  typeof SaleVehicleAlbumPhotoResponseBodySchema
>;
export const GetSaleVehicleAlbumPhotoListApiResponseSchema = z.array(
  SaleVehicleAlbumPhotoResponseBodySchema
);
export type GetSaleVehicleAlbumPhotoListApiResponse = z.infer<
  typeof GetSaleVehicleAlbumPhotoListApiResponseSchema
>;
export const GetSaleVehicleAlbumPhotoListApiArgSchema = z.object({
  saleVehicleId: z.string(),
  saleVehicleAlbumId: z.string(),
});
export type GetSaleVehicleAlbumPhotoListApiArg = z.infer<
  typeof GetSaleVehicleAlbumPhotoListApiArgSchema
>;
export const DeleteSaleVehicleAlbumApiResponseSchema = z.undefined();
export type DeleteSaleVehicleAlbumApiResponse = z.infer<
  typeof DeleteSaleVehicleAlbumApiResponseSchema
>;
export const DeleteSaleVehicleAlbumApiArgSchema = z.object({
  saleVehicleAlbumId: z.string(),
});
export type DeleteSaleVehicleAlbumApiArg = z.infer<typeof DeleteSaleVehicleAlbumApiArgSchema>;
export const SaleVehiclePhotoPositionDtoSchema = z.object({
  fileId: z.string(),
  position: z.number(),
});
export type SaleVehiclePhotoPositionDto = z.infer<typeof SaleVehiclePhotoPositionDtoSchema>;
export const SaleVehiclePhotoCopyRequestBodySchema = z.object({
  photos: z.array(SaleVehiclePhotoPositionDtoSchema),
  sourceAlbum: z.string(),
  destinationAlbum: z.string(),
  position: z.number().nullable().optional(),
});
export type SaleVehiclePhotoCopyRequestBody = z.infer<typeof SaleVehiclePhotoCopyRequestBodySchema>;
export const CopySaleVehiclePhotoApiResponseSchema = z.unknown();
export type CopySaleVehiclePhotoApiResponse = z.infer<typeof CopySaleVehiclePhotoApiResponseSchema>;
export const CopySaleVehiclePhotoApiArgSchema = z.object({
  saleVehicleId: z.string(),
  saleVehiclePhotoCopyRequestBody: SaleVehiclePhotoCopyRequestBodySchema,
});
export type CopySaleVehiclePhotoApiArg = z.infer<typeof CopySaleVehiclePhotoApiArgSchema>;
export type RotateSaleVehiclePhotosRequestBody = {
  saleVehiclePhotoIds: string[];
  angle: 90 | 180 | 270;
};
export const UuidResponseBodySaleVehiclePhotosSchema = z.object({
  id: z.string(),
});
export type UuidResponseBodySaleVehiclePhotos = z.infer<
  typeof UuidResponseBodySaleVehiclePhotosSchema
>;
export const RotateSaleVehiclePhotosApiResponseSchema = UuidResponseBodySaleVehiclePhotosSchema;

export type RotateSaleVehiclePhotosApiResponse = z.infer<
  typeof RotateSaleVehiclePhotosApiResponseSchema
>;
export type RotateSaleVehiclePhotosApiArg = {
  saleVehicleId: string;
  saleVehicleAlbumId: string;
  rotateSaleVehiclePhotosRequestBody: RotateSaleVehiclePhotosRequestBody;
};
export const SetSaleVehicleAlbumCoverPhotoApiResponseSchema = z.unknown();
export type SetSaleVehicleAlbumCoverPhotoApiResponse = z.infer<
  typeof SetSaleVehicleAlbumCoverPhotoApiResponseSchema
>;
export const SetSaleVehicleAlbumCoverPhotoApiArgSchema = z.object({
  saleVehicleAlbumId: z.string(),
  saleVehiclePhotoId: z.string(),
});
export type SetSaleVehicleAlbumCoverPhotoApiArg = z.infer<
  typeof SetSaleVehicleAlbumCoverPhotoApiArgSchema
>;
export const UnsetSaleVehicleAlbumCoverPhotoApiResponseSchema = z.unknown();
export type UnsetSaleVehicleAlbumCoverPhotoApiResponse = z.infer<
  typeof UnsetSaleVehicleAlbumCoverPhotoApiResponseSchema
>;
export const UnsetSaleVehicleAlbumCoverPhotoApiArgSchema = z.object({
  saleVehicleAlbumId: z.string(),
});
export type UnsetSaleVehicleAlbumCoverPhotoApiArg = z.infer<
  typeof UnsetSaleVehicleAlbumCoverPhotoApiArgSchema
>;
export const SaleVehicleAlbumByVehicleResponseBodySchema = z.object({
  translation: z.string(),
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  photosUpdatedAt: z.string().nullable(),
  saleVehicleId: z.string(),
  active: z.boolean(),
  saleVehicleCreatedAt: z.string(),
});
export type SaleVehicleAlbumByVehicleResponseBody = z.infer<
  typeof SaleVehicleAlbumByVehicleResponseBodySchema
>;
export const ListSaleVehicleAlbumsByVehicleApiResponseSchema = z.array(
  SaleVehicleAlbumByVehicleResponseBodySchema
);
export type ListSaleVehicleAlbumsByVehicleApiResponse = z.infer<
  typeof ListSaleVehicleAlbumsByVehicleApiResponseSchema
>;
export const ListSaleVehicleAlbumsByVehicleApiArgSchema = z.object({
  vehicleId: z.string().optional(),
});
export type ListSaleVehicleAlbumsByVehicleApiArg = z.infer<
  typeof ListSaleVehicleAlbumsByVehicleApiArgSchema
>;
export const SaleVehiclePhotoDtoSchema = z.object({
  fileId: z.string(),
});
export type SaleVehiclePhotoDto = z.infer<typeof SaleVehiclePhotoDtoSchema>;
export const SaleVehiclePhotoDeleteRequestBodySchema = z.object({
  photos: z.array(SaleVehiclePhotoDtoSchema),
});
export type SaleVehiclePhotoDeleteRequestBody = z.infer<
  typeof SaleVehiclePhotoDeleteRequestBodySchema
>;
export const DeleteSaleVehiclePhotoApiResponseSchema = z.unknown();
export type DeleteSaleVehiclePhotoApiResponse = z.infer<
  typeof DeleteSaleVehiclePhotoApiResponseSchema
>;
export const DeleteSaleVehiclePhotoApiArgSchema = z.object({
  saleVehicleId: z.string(),
  saleVehicleAlbumId: z.string(),
  saleVehiclePhotoDeleteRequestBody: SaleVehiclePhotoDeleteRequestBodySchema,
});
export type DeleteSaleVehiclePhotoApiArg = z.infer<typeof DeleteSaleVehiclePhotoApiArgSchema>;
export const SaleVehiclePhotoUpdateAlbumRequestBodySchema = z.object({
  photos: z.array(SaleVehiclePhotoPositionDtoSchema),
  sourceAlbum: z.string(),
  destinationAlbum: z.string(),
  position: z.number().nullish(),
});
export type SaleVehiclePhotoUpdateAlbumRequestBody = z.infer<
  typeof SaleVehiclePhotoUpdateAlbumRequestBodySchema
>;
export const UpdateSaleVehiclePhotoAlbumApiResponseSchema = z.unknown();
export type UpdateSaleVehiclePhotoAlbumApiResponse = z.infer<
  typeof UpdateSaleVehiclePhotoAlbumApiResponseSchema
>;
export const UpdateSaleVehiclePhotoAlbumApiArgSchema = z.object({
  saleVehiclePhotoUpdateAlbumRequestBody: SaleVehiclePhotoUpdateAlbumRequestBodySchema,
});
export type UpdateSaleVehiclePhotoAlbumApiArg = z.infer<
  typeof UpdateSaleVehiclePhotoAlbumApiArgSchema
>;
export const DownloadGalleryResponseBodySchema = z.object({
  eventId: z.string(),
});
export type DownloadGalleryResponseBody = z.infer<typeof DownloadGalleryResponseBodySchema>;
export const DownloadSaleVehicleGalleryApiResponseSchema = DownloadGalleryResponseBodySchema;
export type DownloadSaleVehicleGalleryApiResponse = z.infer<
  typeof DownloadSaleVehicleGalleryApiResponseSchema
>;
export const DownloadSaleVehicleGalleryApiArgSchema = z.object({
  saleVehicleId: z.string(),
  albumId: z.string().nullish(),
});
export type DownloadSaleVehicleGalleryApiArg = z.infer<
  typeof DownloadSaleVehicleGalleryApiArgSchema
>;
export const RemoveSaleVehiclePhotosBackgroundRequestBodySchema = z.object({
  saleVehiclePhotoIds: z.array(z.string()),
  backgroundRemovalSettingId: z.string().nullish(),
});
export type RemoveSaleVehiclePhotosBackgroundRequestBody = z.infer<
  typeof RemoveSaleVehiclePhotosBackgroundRequestBodySchema
>;
export const RemoveSaleVehiclePhotosBackgroundApiResponseSchema = UuidResponseBodySchema;
export type RemoveSaleVehiclePhotosBackgroundApiResponse = z.infer<
  typeof RemoveSaleVehiclePhotosBackgroundApiResponseSchema
>;
export const RemoveSaleVehiclePhotosBackgroundApiArgSchema = z.object({
  saleVehicleId: z.string(),
  saleVehicleAlbumId: z.string(),
  removeSaleVehiclePhotosBackgroundRequestBody: RemoveSaleVehiclePhotosBackgroundRequestBodySchema,
});

export type RemoveSaleVehiclePhotosBackgroundApiArg = z.infer<
  typeof RemoveSaleVehiclePhotosBackgroundApiArgSchema
>;

export const GetSaleVehiclePreviewResponseBodySchema = z.object({
  content: z.string(),
});

export type GetSaleVehiclePreviewResponseBody = z.infer<
  typeof GetSaleVehiclePreviewResponseBodySchema
>;

export const GetSaleVehiclePreviewApiResponseSchema = GetSaleVehiclePreviewResponseBodySchema;

export type GetSaleVehiclePreviewApiResponse = z.infer<
  typeof GetSaleVehiclePreviewApiResponseSchema
>;
export const GetSaleVehiclePreviewApiArgSchema = z.object({
  saleVehiclePhotoId: z.string(),
});
export type GetSaleVehiclePreviewApiArg = z.infer<typeof GetSaleVehiclePreviewApiArgSchema>;

// PROMOTIONAL PHOTOS API
// `id` is the vehicle↔promo relation (used for remove/positions); `promotionalPhotoId` is the
// catalog item. A FINANCING card has no file until its render is READY.
export const SaleVehiclePromoPhotoResponseBodySchema = z.object({
  id: z.string(),
  promotionalPhotoId: z.string(),
  type: PromotionalPhotoTypeSchema,
  position: z.number(),
  positionInSettings: z.number(),
  fileId: z.string().nullable(),
  remoteFileId: z.string().nullable(),
  url: z.string().nullable(),
});
export type SaleVehiclePromoPhotoResponseBody = z.infer<
  typeof SaleVehiclePromoPhotoResponseBodySchema
>;
export const AddToSaleVehicleRequestBodySchema = z.object({
  saleVehicleId: z.string(),
});
export type AddToSaleVehicleRequestBody = z.infer<typeof AddToSaleVehicleRequestBodySchema>;
export const AddToSaleVehicleApiResponseSchema = z.array(SaleVehiclePromoPhotoResponseBodySchema);
export type AddToSaleVehicleApiResponse = z.infer<typeof AddToSaleVehicleApiResponseSchema>;
export const AddToSaleVehicleApiArgSchema = z.object({
  addToSaleVehicleRequestBody: AddToSaleVehicleRequestBodySchema,
});
export type AddToSaleVehicleApiArg = z.infer<typeof AddToSaleVehicleApiArgSchema>;
export const GetForSaleVehicleApiResponseSchema = z.array(SaleVehiclePromoPhotoResponseBodySchema);
export type GetForSaleVehicleApiResponse = z.infer<typeof GetForSaleVehicleApiResponseSchema>;
export const GetForSaleVehicleApiArgSchema = z.object({
  saleVehicleId: z.string(),
});
export type GetForSaleVehicleApiArg = z.infer<typeof GetForSaleVehicleApiArgSchema>;
export const RemoveInSaleVehicleRequestBodySchema = z.object({
  saleVehiclePromoPhotoId: z.string(),
});
export type RemoveInSaleVehicleRequestBody = z.infer<typeof RemoveInSaleVehicleRequestBodySchema>;
export const UpdatePositionInSaleVehicleRequestBodySchema = z.object({
  saleVehiclePromoPhotoId: z.string(),
  position: z.number(),
});
export type UpdatePositionInSaleVehicleRequestBody = z.infer<
  typeof UpdatePositionInSaleVehicleRequestBodySchema
>;
export const UpdatePositionsInSaleVehicleRequestBodySchema = z.object({
  positions: z.array(UpdatePositionInSaleVehicleRequestBodySchema),
});
export type UpdatePositionsInSaleVehicleRequestBody = z.infer<
  typeof UpdatePositionsInSaleVehicleRequestBodySchema
>;
export const RemoveInSaleVehicleApiResponseSchema = z.unknown();
export type RemoveInSaleVehicleApiResponse = z.infer<typeof RemoveInSaleVehicleApiResponseSchema>;
export const RemoveInSaleVehicleApiArgSchema = z.object({
  removeInSaleVehicleRequestBody: RemoveInSaleVehicleRequestBodySchema,
});
export type RemoveInSaleVehicleApiArg = z.infer<typeof RemoveInSaleVehicleApiArgSchema>;
export const SaleVehicleCoverPhotoResponseBodySchema = z.object({
  id: z.string(),
  fileId: z.string(),
  remoteFileId: z.string(),
  saleVehicleAlbumId: z.string(),
  uri: z.string(),
});
export type SaleVehicleCoverPhotoResponseBody = z.infer<
  typeof SaleVehicleCoverPhotoResponseBodySchema
>;
export const GetSaleVehicleCoverPhotoApiResponseSchema = SaleVehicleCoverPhotoResponseBodySchema;
export type GetSaleVehicleCoverPhotoApiResponse = z.infer<
  typeof GetSaleVehicleCoverPhotoApiResponseSchema
>;
export const GetSaleVehicleCoverPhotoApiArgSchema = z.object({
  saleVehicleId: z.string(),
});
export type GetSaleVehicleCoverPhotoApiArg = z.infer<typeof GetSaleVehicleCoverPhotoApiArgSchema>;
export const UpdatePositionsInSaleVehicleApiResponseSchema = z.unknown();
export type UpdatePositionsInSaleVehicleApiResponse = z.infer<
  typeof UpdatePositionsInSaleVehicleApiResponseSchema
>;
export const UpdatePositionsInSaleVehicleApiArgSchema = z.object({
  updatePositionsInSaleVehicleRequestBody: UpdatePositionsInSaleVehicleRequestBodySchema,
});
export type UpdatePositionsInSaleVehicleApiArg = z.infer<
  typeof UpdatePositionsInSaleVehicleApiArgSchema
>;
export const ResetPositionsInSaleVehicleRequestBodySchema = z.object({
  saleVehicleId: z.string(),
});
export type ResetPositionsInSaleVehicleRequestBody = z.infer<
  typeof ResetPositionsInSaleVehicleRequestBodySchema
>;
export const ResetPositionsInSaleVehicleApiResponseSchema = z.array(
  SaleVehiclePromoPhotoResponseBodySchema
);
export type ResetPositionsInSaleVehicleApiResponse = z.infer<
  typeof ResetPositionsInSaleVehicleApiResponseSchema
>;
export const ResetPositionsInSaleVehicleApiArgSchema = z.object({
  resetPositionsInSaleVehicleRequestBody: ResetPositionsInSaleVehicleRequestBodySchema,
});
export type ResetPositionsInSaleVehicleApiArg = z.infer<
  typeof ResetPositionsInSaleVehicleApiArgSchema
>;
export const SaleVehiclePhotoListResponseBodySchema = z.object({
  photos: z.array(SaleVehiclePhotoResponseBodySchema),
});
export type SaleVehiclePhotoListResponseBody = z.infer<
  typeof SaleVehiclePhotoListResponseBodySchema
>;
export const GetSaleVehiclePhotoListApiResponseSchema = SaleVehiclePhotoListResponseBodySchema;
export type GetSaleVehiclePhotoListApiResponse = z.infer<
  typeof GetSaleVehiclePhotoListApiResponseSchema
>;
export const GetSaleVehiclePhotoListApiArgSchema = z.object({
  saleVehicleId: z.string(),
});
export type GetSaleVehiclePhotoListApiArg = z.infer<typeof GetSaleVehiclePhotoListApiArgSchema>;
export const SaleVehicleAuditPhotoCopyRequestBodySchema = z.object({
  auditId: z.string(),
  auditCategoryId: z.string(),
  saleVehicleAlbumId: z.string(),
});
export type SaleVehicleAuditPhotoCopyRequestBody = z.infer<
  typeof SaleVehicleAuditPhotoCopyRequestBodySchema
>;
export const CopyAuditPhotoToSaleVehicleAlbumApiResponseSchema = z.unknown();
export type CopyAuditPhotoToSaleVehicleAlbumApiResponse = z.infer<
  typeof CopyAuditPhotoToSaleVehicleAlbumApiResponseSchema
>;
export const CopyAuditPhotoToSaleVehicleAlbumApiArgSchema = z.object({
  saleVehicleId: z.string(),
  saleVehicleAuditPhotoCopyRequestBody: SaleVehicleAuditPhotoCopyRequestBodySchema,
});

export type CopyAuditPhotoToSaleVehicleAlbumApiArg = z.infer<
  typeof CopyAuditPhotoToSaleVehicleAlbumApiArgSchema
>;
export const ListSaleVehiclePhotosByVehicleApiResponseSchema =
  SaleVehiclePhotoListResponseBodySchema;
export type ListSaleVehiclePhotosByVehicleApiResponse = z.infer<
  typeof ListSaleVehiclePhotosByVehicleApiResponseSchema
>;
export const ListSaleVehiclePhotosByVehicleApiArgSchema = z.object({
  vehicleId: z.string().optional(),
});
export type ListSaleVehiclePhotosByVehicleApiArg = z.infer<
  typeof ListSaleVehiclePhotosByVehicleApiArgSchema
>;
export const PatchSaleVehicleSalePresetRequestBodySchema = z.object({
  salePresetId: z.string().nullable(),
});

export const PatchSaleVehicleSalePresetApiArgSchema = z.object({
  vehicleId: z.string(),
  patchSaleVehicleSalePresetRequestBody: PatchSaleVehicleSalePresetRequestBodySchema,
});

export type PatchSaleVehicleSalePresetRequestBody = z.infer<
  typeof PatchSaleVehicleSalePresetRequestBodySchema
>;
export type PatchSaleVehicleSalePresetApiArg = z.infer<
  typeof PatchSaleVehicleSalePresetApiArgSchema
>;
export type PatchSaleVehicleSalePresetApiResponse = unknown;

// General sale-vehicle PATCH (`PATCH /dms/v1/sales/sale-vehicle/{vehicleId}`). All fields are
// optional so callers can patch a single field; omitted fields are left unchanged by the BE.
export const PatchSaleVehicleRequestBodySchema = z.object({
  warrantyProgramId: z.string().nullable().optional(),
  warrantyDuration: z.number().nullable().optional(),
  salePresetId: z.string().nullable().optional(),
  qualitySealKey: z.string().nullable().optional(),
  vehicleSourceCodeId: z.string().nullable().optional(),
});

export const PatchSaleVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  patchSaleVehicleRequestBody: PatchSaleVehicleRequestBodySchema,
});

export type PatchSaleVehicleRequestBody = z.infer<typeof PatchSaleVehicleRequestBodySchema>;
export type PatchSaleVehicleApiArg = z.infer<typeof PatchSaleVehicleApiArgSchema>;
export type PatchSaleVehicleApiResponse = unknown;
export const PatchSaleVehicleWatermarkApiResponseSchema = z.unknown();
export type PatchSaleVehicleWatermarkApiResponse = z.infer<
  typeof PatchSaleVehicleWatermarkApiResponseSchema
>;
export const PatchSaleVehicleWatermarkRequestBodySchema = z.object({
  watermarkId: z.string().nullable(),
});
export type PatchSaleVehicleWatermarkRequestBody = z.infer<
  typeof PatchSaleVehicleWatermarkRequestBodySchema
>;
export const PatchSaleVehicleWatermarkApiArgSchema = z.object({
  vehicleId: z.string(),
  patchSaleVehicleWatermarkRequestBody: PatchSaleVehicleWatermarkRequestBodySchema,
});
export type PatchSaleVehicleWatermarkApiArg = z.infer<typeof PatchSaleVehicleWatermarkApiArgSchema>;
export const PatchSaleVehicleWatermarkV2ApiResponseSchema = z.unknown();
export type PatchSaleVehicleWatermarkV2ApiResponse = z.infer<
  typeof PatchSaleVehicleWatermarkV2ApiResponseSchema
>;
export const PatchSaleVehicleWatermarkV2RequestBodySchema = z.object({
  watermarkIds: z.array(z.string()).max(9),
});
export type PatchSaleVehicleWatermarkV2RequestBody = z.infer<
  typeof PatchSaleVehicleWatermarkV2RequestBodySchema
>;
export const PatchSaleVehicleWatermarkV2ApiArgSchema = z.object({
  vehicleId: z.string(),
  patchSaleVehicleWatermarkV2RequestBody: PatchSaleVehicleWatermarkV2RequestBodySchema,
});
export type PatchSaleVehicleWatermarkV2ApiArg = z.infer<
  typeof PatchSaleVehicleWatermarkV2ApiArgSchema
>;

export const VehicleCostCategoryResponseBodySchema = z.array(
  z.object({
    key: z.string(),
    name: z.string(),
  })
);
export type ListVehicleCostCategoriesApiResponse = z.infer<
  typeof VehicleCostCategoryResponseBodySchema
>;

export const ListVehicleCostCategoriesApiArgSchema = z.object({});
export type ListVehicleCostCategoriesApiArg = z.infer<typeof ListVehicleCostCategoriesApiArgSchema>;

export const PatchSaleVehiclePhotosCategoryRequestBodySchema = z.object({
  saleVehiclePhotoIds: z.array(z.string()),
  category: VehiclePhotoCategorySchema.nullable(),
});
export type PatchSaleVehiclePhotosCategoryRequestBody = z.infer<
  typeof PatchSaleVehiclePhotosCategoryRequestBodySchema
>;

export type PatchSaleVehiclePhotosCategoryApiResponse = /** status 204  */ void;
export type PatchSaleVehiclePhotosCategoryApiArg = {
  saleVehicleId: string;
  saleVehicleAlbumId: string;
  patchSaleVehiclePhotosCategoryRequestBody: PatchSaleVehiclePhotosCategoryRequestBody;
};

export const OneTimePriceSchema = z.object({
  vatType: z.string(),
  vatRate: BigDecimalSchema,
  withoutVat: MoneySchema,
  withVat: MoneySchema,
  vatDirection: z.enum(['FROM_PRICE_WITHOUT_VAT', 'FROM_PRICE_WITH_VAT']),
});

export const RecurringPriceSimpleSchema = z.object({
  startDate: z.string(),
  endDate: z.string().nullable(),
  price: MoneySchema,
});

export const RecurringPriceCalculatedSchema = z.object({
  startDate: z.string(),
  endDate: z.string().nullable(),
  basePrice: MoneySchema,
  interestRate: BigDecimalSchema,
});

export const VehicleCostRequestBodySchema = z.object({
  name: z.string(),
  category: z.string().nullable(),
  expectedPrice: OneTimePriceSchema.nullable(),
  realPriceOneTime: OneTimePriceSchema.nullable(),
  realPriceRecurringSimple: RecurringPriceSimpleSchema.nullable(),
  realPriceRecurringCalculated: RecurringPriceCalculatedSchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});

export const VehicleCostResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
  category: z.string().nullable(),
  expectedPrice: OneTimePriceSchema.nullable(),
  realPriceOneTime: OneTimePriceSchema.nullable(),
  realPriceRecurringSimple: RecurringPriceSimpleSchema.nullable(),
  realPriceRecurringCalculated: RecurringPriceCalculatedSchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});

export const AddVehicleCostApiArgSchema = z.object({
  vehicleId: z.string(),
  addVehicleCostRequestBody: VehicleCostRequestBodySchema,
});

export const GetVehicleCostApiArgSchema = z.object({
  vehicleId: z.string(),
  costId: z.string(),
});

export const UpdateVehicleCostApiResponseSchema = z.unknown();

export const UpdateVehicleCostApiArgSchema = z.object({
  vehicleId: z.string(),
  costId: z.string(),
  updateVehicleCostRequestBody: VehicleCostRequestBodySchema,
});

export type OneTimePrice = z.infer<typeof OneTimePriceSchema>;
export type RecurringPriceSimple = z.infer<typeof RecurringPriceSimpleSchema>;
export type RecurringPriceCalculated = z.infer<typeof RecurringPriceCalculatedSchema>;
export type AddVehicleCostRequestBody = z.infer<typeof VehicleCostRequestBodySchema>;
export type VehicleCostResponseBody = z.infer<typeof VehicleCostResponseBodySchema>;
export type AddVehicleCostApiArg = z.infer<typeof AddVehicleCostApiArgSchema>;
export type GetVehicleCostApiArg = z.infer<typeof GetVehicleCostApiArgSchema>;
export type GetVehicleCostApiResponse = VehicleCostResponseBody;

export const AddVehicleCostApiResponseSchema = UuidResponseBodySchema;
export type AddVehicleCostApiResponse = z.infer<typeof AddVehicleCostApiResponseSchema>;

export type UpdateVehicleCostApiResponse = z.infer<typeof UpdateVehicleCostApiResponseSchema>;
export type UpdateVehicleCostApiArg = z.infer<typeof UpdateVehicleCostApiArgSchema>;

export const EarningCategoryEnumSchema = z.enum([
  'VEHICLE',
  'BROKERAGE',
  'UPSELL',
  'FINANCING',
  'INSURANCE',
  'WARRANTY',
  'SERVICE_CONTRACT',
  'SERVICE_FEE',
]);
export type EarningCategoryEnum = z.infer<typeof EarningCategoryEnumSchema>;

export const VehicleEarningResponseBodySchema = z.object({
  id: z.string(),
  name: z.string(),
  category: EarningCategoryEnumSchema.nullable(),
  expectedPrice: OneTimePriceSchema.nullable(),
  realPrice: OneTimePriceSchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});
export type VehicleEarningResponseBody = z.infer<typeof VehicleEarningResponseBodySchema>;

export const AddVehicleEarningRequestBodySchema = z.object({
  name: z.string(),
  category: EarningCategoryEnumSchema.nullable(),
  expectedPrice: OneTimePriceSchema.nullable(),
  realPrice: OneTimePriceSchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});
export type AddVehicleEarningRequestBody = z.infer<typeof AddVehicleEarningRequestBodySchema>;

export const AddVehicleEarningApiArgSchema = z.object({
  vehicleId: z.string(),
  addVehicleEarningRequestBody: AddVehicleEarningRequestBodySchema,
});
export type AddVehicleEarningApiArg = z.infer<typeof AddVehicleEarningApiArgSchema>;

export const AddVehicleEarningApiResponseSchema = UuidResponseBodySchema;
export type AddVehicleEarningApiResponse = z.infer<typeof AddVehicleEarningApiResponseSchema>;

export const GetVehicleEarningApiArgSchema = z.object({
  vehicleId: z.string(),
  earningId: z.string(),
});
export type GetVehicleEarningApiArg = z.infer<typeof GetVehicleEarningApiArgSchema>;

export const GetVehicleEarningApiResponseSchema = VehicleEarningResponseBodySchema;
export type GetVehicleEarningApiResponse = z.infer<typeof GetVehicleEarningApiResponseSchema>;

export const UpdateVehicleEarningRequestBodySchema = z.object({
  name: z.string(),
  category: EarningCategoryEnumSchema.nullable(),
  expectedPrice: OneTimePriceSchema.nullable(),
  realPrice: OneTimePriceSchema.nullable(),
  note: z.string().nullable(),
  fileId: z.string().nullable(),
});
export type UpdateVehicleEarningRequestBody = z.infer<typeof UpdateVehicleEarningRequestBodySchema>;

export const UpdateVehicleEarningApiArgSchema = z.object({
  vehicleId: z.string(),
  earningId: z.string(),
  updateVehicleEarningRequestBody: UpdateVehicleEarningRequestBodySchema,
});
export type UpdateVehicleEarningApiArg = z.infer<typeof UpdateVehicleEarningApiArgSchema>;

export const UpdateVehicleEarningApiResponseSchema = z.void();
export type UpdateVehicleEarningApiResponse = z.infer<typeof UpdateVehicleEarningApiResponseSchema>;

export const VehicleEarningCategoryResponseBodySchema = z.object({
  key: EarningCategoryEnumSchema,
  name: z.string(),
});
export type VehicleEarningCategoryResponseBody = z.infer<
  typeof VehicleEarningCategoryResponseBodySchema
>;

export const ListVehicleEarningCategoriesApiResponseSchema = z.array(
  VehicleEarningCategoryResponseBodySchema
);
export type ListVehicleEarningCategoriesApiResponse = z.infer<
  typeof ListVehicleEarningCategoriesApiResponseSchema
>;

export const ListVehicleEarningCategoriesApiArgSchema = z.object({});
export type ListVehicleEarningCategoriesApiArg = z.infer<
  typeof ListVehicleEarningCategoriesApiArgSchema
>;

export type GetPriceSnapshotsApiResponse = /** status 200  */ PriceSnapshotListResponseBody;
export type GetPriceSnapshotsApiArg = {
  vehicleId: string;
};
export type PriceSnapshotResponseBody = {
  createdAt: string;
  sellingPriceWithVat: Money | null;
};
export type PriceSnapshotListResponseBody = {
  snapshots: PriceSnapshotResponseBody[];
};

export const CorrectVehicleSaleDateRequestBodySchema = z.object({
  saleDate: z.string(),
});
export type CorrectVehicleSaleDateRequestBody = z.infer<
  typeof CorrectVehicleSaleDateRequestBodySchema
>;
export const CorrectVehicleSaleDateApiArgSchema = z.object({
  vehicleId: z.string(),
  correctVehicleSaleDateRequestBody: CorrectVehicleSaleDateRequestBodySchema,
});
export type CorrectVehicleSaleDateApiArg = z.infer<typeof CorrectVehicleSaleDateApiArgSchema>;
export const CorrectVehicleSaleDateApiResponseSchema = z.unknown();
export type CorrectVehicleSaleDateApiResponse = z.infer<
  typeof CorrectVehicleSaleDateApiResponseSchema
>;

export const CorrectVehiclePurchaseDateRequestBodySchema = z.object({
  purchaseDate: z.string(),
});
export type CorrectVehiclePurchaseDateRequestBody = z.infer<
  typeof CorrectVehiclePurchaseDateRequestBodySchema
>;
export const CorrectVehiclePurchaseDateApiArgSchema = z.object({
  vehicleId: z.string(),
  correctVehiclePurchaseDateRequestBody: CorrectVehiclePurchaseDateRequestBodySchema,
});
export type CorrectVehiclePurchaseDateApiArg = z.infer<
  typeof CorrectVehiclePurchaseDateApiArgSchema
>;
export const CorrectVehiclePurchaseDateApiResponseSchema = z.unknown();
export type CorrectVehiclePurchaseDateApiResponse = z.infer<
  typeof CorrectVehiclePurchaseDateApiResponseSchema
>;

export const BuyVehicleRequestBodySchema = z.object({
  purchaseDate: z.string(),
});
export type BuyVehicleRequestBody = z.infer<typeof BuyVehicleRequestBodySchema>;
export const BuyVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  buyVehicleRequestBody: BuyVehicleRequestBodySchema,
});
export type BuyVehicleApiArg = z.infer<typeof BuyVehicleApiArgSchema>;
export const BuyVehicleApiResponseSchema = z.unknown();
export type BuyVehicleApiResponse = z.infer<typeof BuyVehicleApiResponseSchema>;

export const SellVehicleRequestBodySchema = z.object({
  saleDate: z.string(),
});
export type SellVehicleRequestBody = z.infer<typeof SellVehicleRequestBodySchema>;
export const SellVehicleApiArgSchema = z.object({
  vehicleId: z.string(),
  sellVehicleRequestBody: SellVehicleRequestBodySchema,
});
export type SellVehicleApiArg = z.infer<typeof SellVehicleApiArgSchema>;
export const SellVehicleApiResponseSchema = z.unknown();
export type SellVehicleApiResponse = z.infer<typeof SellVehicleApiResponseSchema>;
